import _ from 'lodash'

const getNode = elOrRef => {
  return elOrRef?.current || elOrRef
}

const getNodes = elements => _.compact(_.map(elements, getNode))

export default getNodes
